import { useEffect, useState } from "react";
import { FileText, Users, Store, Image as ImageIcon } from "lucide-react";
import { api } from "../../lib/api";

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-slate-500">{label}</span>
        <Icon className="h-5 w-5 text-emerald-500" />
      </div>
      <div className="mt-3 font-heading text-3xl font-black text-slate-900">{value ?? "—"}</div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/api/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/api/admin/events/summary").then(({ data }) => setEvents(data)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="font-heading text-2xl font-extrabold text-slate-900">Dashboard</h1>
      <p className="mt-1 text-sm text-slate-500">Overview of your LIVYVIO content platform.</p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat icon={FileText} label="Content items" value={stats?.content_total} />
        <Stat icon={Users} label="Users" value={stats?.users} />
        <Stat icon={Store} label="Merchants" value={stats?.merchants} />
        <Stat icon={ImageIcon} label="Media assets" value={stats?.media} />
      </div>

      <div className="mt-8 grid gap-6 lg:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <h2 className="font-heading text-lg font-bold text-slate-900">Content by status</h2>
          <div className="mt-4 space-y-2">
            {stats && Object.entries(stats.by_status).map(([k, v]) => (
              <div key={k} className="flex items-center justify-between text-sm">
                <span className="capitalize text-slate-600">{k}</span>
                <span className="font-semibold text-slate-900">{v}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <h2 className="font-heading text-lg font-bold text-slate-900">Content by type</h2>
          <div className="mt-4 grid grid-cols-2 gap-2">
            {stats && Object.entries(stats.by_type).map(([k, v]) => (
              <div key={k} className="flex items-center justify-between text-sm">
                <span className="capitalize text-slate-600">{k.replace("_", " ")}</span>
                <span className="font-semibold text-slate-900">{v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {events && (
        <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6">
          <h2 className="font-heading text-lg font-bold text-slate-900">Analytics events <span className="text-sm font-normal text-slate-400">({events.total} total)</span></h2>
          <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3">
            {events.by_event.map((e) => (
              <div key={e.name} className="flex items-center justify-between rounded-lg bg-slate-50 px-3 py-2 text-sm">
                <span className="text-slate-600">{e.name}</span><span className="font-semibold">{e.count}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
